import React, { useContext } from "react";
import { ResponsiveContext } from "grommet";
import {useRouter} from "next/router";
import {
    IconChevronLeft
} from '@tabler/icons-react';
import FontAwesomeIcon from "./FontAwesomeIcon";
import Button from "./Button";
import { goToPrevUrlButSkipSignIn } from "../utils/url";

const Back = ({ url = null, onClick, iconProps={} }) => {
    const router = useRouter();
    const isPhone = useContext(ResponsiveContext) === "small";
    return (
        <Button
            event={{element: 'page_back_button'}}
            a11yTitle="Back"
            // A full 44px square to tap on a phone
            {...(isPhone ? {style: {minWidth: '44px', minHeight: '44px'}} : {})}
            alignSelf="start"
            margin={{ left: 'xxsmall' }}
            hoverIndicator
            label={<FontAwesomeIcon SelectedIcon={IconChevronLeft} size="medium" {...iconProps} />}
            onClick={onClick ?
                onClick :
                goToPrevUrlButSkipSignIn({fallbackUrl: url, router})
            }
        />
    );
};

export default Back;
